import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";
import * as fromPermSetStates from "../perm-set-controller/states/perm-set.states";
import * as fromUserPermStates from "../user-permissions-controller/states/user-permissions.states";
import * as fromTeamPermStates from "../team-permissions-controller/states/team-permissions.states";
import * as fromRolePermStates from "../role-permissions-controller/states/role-permissions.states";
import * as fromClientPermStates from "../client-side-permissions-controller/states/client-side-permission.states";
import * as fromPermSetReducers from "../perm-set-controller/reducers/perm-set.reducers";
import * as fromPermWizardStates from "../permission-wizard-controller/states/permission-wizard.states"
import * as fromRolePermReducers from "../role-permissions-controller/reducers/role-permissions.reducers";
import * as fromClientPermReducers from "../client-side-permissions-controller/reducers/client-side-permission.reducers";
import * as fromTeamPermReducers from "../team-permissions-controller/reducers/team-permissions.reducers";
import * as fromUserPermReducers from "../user-permissions-controller/reducers/user-permissions.reducers";
import * as fromPermWizardReducers from "../permission-wizard-controller/reducers/permission-wizard.reducers"
import * as fromUserPermInquiryStates from "../user-permissions-inquiry-controller/states/user-permissions-inquiry.states";
import * as fromUserInquiryPermReducers from "../user-permissions-inquiry-controller/reducers/user-permissions-inquiry.reducers";
import * as fromRolePricingSchemeLinkStates from "../role-pricing-scheme-link-controler/states/role-pricing-scheme-link.states";
import * as fromRolePricingSchemeLinkReducers from "../role-pricing-scheme-link-controler/reducers/role-pricing-scheme-link.reducers";

export const permissionsFeatureKey = 'permissions';

export interface PermState {
  permSet: fromPermSetStates.PermSetState;
  permWizard: fromPermWizardStates.PermWizardState;
  userPerm: fromUserPermStates.UserPermState;
  teamPerm: fromTeamPermStates.TeamPermState;
  rolePerm: fromRolePermStates.RolePermState;
  clientSide: fromClientPermStates.ClientSidePermissionsState;
  userPermInquiry: fromUserPermInquiryStates.UserPermInquiryState;
  rolePricingSchemeLink: fromRolePricingSchemeLinkStates.RolePricingSchemeLinkState
}

export interface PermissionStates {
  permissions: PermState;
}

export const reducers: ActionReducerMap<PermState> = {
  permSet: fromPermSetReducers.permSetReducer,
  permWizard: fromPermWizardReducers.permWizardReducer,
  userPerm: fromUserPermReducers.userPermReducer,
  teamPerm: fromTeamPermReducers.teamPermReducer,
  rolePerm: fromRolePermReducers.rolePermReducer,
  clientSide: fromClientPermReducers.clientSidePermissionsReducer,
  userPermInquiry: fromUserInquiryPermReducers.userPermInquiryReducer,
  rolePricingSchemeLink: fromRolePricingSchemeLinkReducers.rolePricingSchemeLinkReducer
};

export const getPermissionsState = createFeatureSelector<PermState>(permissionsFeatureKey)

